import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'

// helper
import { singleLetterNumberOptionSelect } from '../../../helpers/format-options'

const AppForm = ({
  values,
  errors,
  handleSelectLetterType,
  handleChange,
  letterType,
  isEdit = false,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormSelectInput 
          id='letter_type'
          name='letter_type'
          colSize='6'
          inputLabel='Letter Type'
          className='mb-3'
          selectOptions={singleLetterNumberOptionSelect()}
          value={letterType}
          handleSelectInput={(data) => handleSelectLetterType(data)}
          feedbackInvalid={errors?.letter_type}
          invalid={errors?.letter_type}
          disabled={isEdit}
          placeholder='Please select letter type...'
        />
        <FormTextInput 
          id='letter_recipient'
          name='letter_recipient'
          colSize='6'
          inputLabel='Letter Recipient'
          className='mb-3'
          value={values?.letter_recipient}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.letter_recipient}
          invalid={errors?.letter_recipient}
          placeholder='Please enter letter recipient...'
        />
        <FormTextAreaInput 
          id='letter_notes'
          name='letter_notes'
          colSize='6'
          inputLabel='Notes'
          className='mb-3'
          value={values?.letter_notes}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.letter_notes}
          invalid={errors?.letter_notes}
          disabled={false}
          placeholder='Please enter letter notes...'
        />
      </CRow>
    </>
  )
}

export default AppForm